import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  updateNewProductStockResponse,
  updateNewProductStockRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum UpdateNewProductStockState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: UpdateNewProductStockState;
  message: string;
}

const initialState: InitialState = {
  status: UpdateNewProductStockState.initial,
  message: "",
};

export const updateNewProductStock = createAsyncThunk(
  "updateNewProductStock",
  async (
    param: { newStock: number; productId: string | undefined },
    { rejectWithValue }
  ) => {
    try {
      const response: updateNewProductStockResponse =
        await updateNewProductStockRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const updateNewProductStockSlice = createSlice({
  name: "updateNewProductStock",
  initialState,
  reducers: {
    resetupdateNewProductStock: (state) => {
      state.status = UpdateNewProductStockState.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateNewProductStock.pending, (state) => {
        state.status = UpdateNewProductStockState.inProgress;
      })
      .addCase(updateNewProductStock.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = UpdateNewProductStockState.success;
          state.message = message;
        }
      })
      .addCase(updateNewProductStock.rejected, (state, action) => {
        state.status = UpdateNewProductStockState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectUpdateNewProductStock = (state: RootState) =>
  state.updateNewProductStock;

export const { resetupdateNewProductStock } =
  updateNewProductStockSlice.actions;
export default updateNewProductStockSlice.reducer;
